import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown, DropdownProps } from '@sato/components';

export const HookFormDropdown = (props: { name: string } & DropdownProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <Dropdown
          {...props}
          {...field}
          selectedKey={field.value ?? null}
          onSelectionChange={field.onChange}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
